import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import MemberProfile from '@components/MasterAccount/MemberProfile';
import SlaveBalanceData from '@components/MasterAccount/SlaveBalanceData';
import DeleteMebmerBtn from '@components/MasterAccount/DeleteMebmerBtn';

const DeleteMemberModal = ({ isOpen, handleClose, balance, slaves }) => {
  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      centered
      autoFocus
      className="delete-member-modal"
    >
      <ModalHeader toggle={handleClose}>
        <MemberProfile slaves={slaves} />
      </ModalHeader>
      <ModalBody>
        <SlaveBalanceData balance={balance} />
        <DeleteMebmerBtn />
      </ModalBody>
    </Modal>
  );
};

export default DeleteMemberModal;
